"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("moment-duration-format");
exports.Hours = 'h', exports.Minutes = 'm', exports.Seconds = 's', exports.MilliSeconds = 'S';
exports.DefaultTimeTemplates = {
    Millis: "" + exports.MilliSeconds,
    SecondsMillis: exports.Seconds + "." + exports.MilliSeconds + exports.MilliSeconds,
    MinutesSeconds: exports.Minutes + ":" + exports.Seconds + exports.Seconds,
    HoursMinutesSeconds: exports.Hours + ":" + exports.Minutes + exports.Minutes + ":" + exports.Seconds + exports.Seconds
};
//# sourceMappingURL=timeCommon.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/lib-athlinks-units/dist/units/timeCommon.js
 ** module id = 1087
 ** module chunks = 0
 **/